export const getImagePath = (imagePath) => {
  if (!imagePath) return null;

  // If it's a relative path starting with /images/, replace it to point to assets
  if (imagePath.startsWith("/images/")) {
    const fileName = imagePath.split("/").pop();
    // Try to import from assets/images
    try {
      return require(`../assets/images/${fileName}`);
    } catch (e) {
      console.warn(`Could not find image: ${fileName} in assets folder`);
      return null;
    }
  }
  return imagePath;
};
